import { Fragment } from 'react';
import { RuterStoppsImage } from './RuterStoppsImage';

import config from '../config';

export const OptionImage = ({ option }) => {
    return (
        <Fragment>
            {option.picture && (
                <RuterStoppsImage
                    style={{ maxWidth: 200, maxHeight: 200 }}
                    objectFit="contain"
                    src={`${config.serverUrl}document/download/lowRes/${option.picture?.filepath}`}
                    className="questionTypeImage"
                    alt={option.value}
                />
            )}
        </Fragment>
    );
};
